import * as animations from 'angular-animations';

export const CSort = { ASC: "asc", DESC: "desc", NUll: 'null' }

export interface ITranslate{ [name: string]: string; }

/**
 * animations
 */
export const CAnimations = [
  animations.bounceInUpOnEnterAnimation({ anchor: 'bounceInUpOnEnter', delay: 200 }),
  animations.bounceInUpOnEnterAnimation({ anchor: 'bounceInUpOnEnter', delay: 200 }),
  animations.bounceInUpOnEnterAnimation({ anchor: 'bounceInUpOnEnter', delay: 200 }),
  animations.bounceAnimation({ anchor: 'bounce', delay: 200 }),
  animations.flashAnimation({ anchor: 'flash', delay: 200 }),
  animations.pulseAnimation({ anchor: 'pulse', delay: 200 }),
  animations.rubberBandAnimation({ anchor: 'rubberBand', delay: 200 }),
  animations.shakeAnimation({ anchor: 'shake', delay: 200 }),
  animations.swingAnimation({ anchor: 'swing', delay: 200 }),
  animations.tadaAnimation({ anchor: 'tada', delay: 200 }),
  animations.wobbleAnimation({ anchor: 'wobble', delay: 200 }),
  animations.jelloAnimation({ anchor: 'jello', delay: 200 }),
  animations.heartBeatAnimation({ anchor: 'heartBeat', delay: 200 }),
  animations.headShakeAnimation({ anchor: 'headShake', delay: 200 }),
  animations.bounceInAnimation({ anchor: 'bounceIn', delay: 200 }),
  animations.bounceInDownAnimation({ anchor: 'bounceInDown', delay: 200 }),
  animations.bounceInLeftAnimation({ anchor: 'bounceInLeft', delay: 200 }),
  animations.bounceInRightAnimation({ anchor: 'bounceInRight', delay: 200 }),
  animations.bounceInUpAnimation({ anchor: 'bounceInUp', delay: 200 }),
  animations.bounceOutAnimation({ anchor: 'bounceOut', delay: 200 }),
  animations.bounceOutDownAnimation({ anchor: 'bounceOutDown', delay: 200 }),
  animations.bounceOutLeftAnimation({ anchor: 'bounceOutLeft', delay: 200 }),
  animations.bounceOutRightAnimation({ anchor: 'bounceOutRight', delay: 200 }),
  animations.bounceOutUpAnimation({ anchor: 'bounceOutUp', delay: 200 }),
  animations.fadeInAnimation({ anchor: 'fadeIn', delay: 200 }),
  animations.fadeInDownAnimation({ anchor: 'fadeInDown', delay: 200 }),
  animations.fadeInDownBigAnimation({ anchor: 'fadeInDownBig', delay: 200 }),
  animations.fadeInLeftAnimation({ anchor: 'fadeInLeft', delay: 200 }),
  animations.fadeInLeftBigAnimation({ anchor: 'fadeInLeft', delay: 200 }),
  animations.fadeInRightAnimation({ anchor: 'fadeInRight', delay: 200 }),
  animations.fadeInRightBigAnimation({ anchor: 'fadeInRightBig', delay: 200 }),
  animations.fadeInUpAnimation({ anchor: 'fadeInUp', duration: 1000, delay: 200 }),
  animations.fadeInUpBigAnimation({ anchor: 'fadeInUpBig', delay: 200 }),
  animations.fadeOutAnimation({ anchor: 'fadeOut', delay: 200 }),
  animations.fadeOutDownAnimation({ anchor: 'fadeOutDown', delay: 200 }),
  animations.fadeOutDownBigAnimation({ anchor: 'fadeOutDownBig', delay: 200 }),
  animations.fadeOutLeftAnimation({ anchor: 'fadeOutLeft', delay: 200 }),
  animations.fadeOutLeftBigAnimation({ anchor: 'fadeOutLeftBig', delay: 200 }),
  animations.fadeOutRightAnimation({ anchor: 'fadeOutRight', delay: 200 }),
  animations.fadeOutRightBigAnimation({ anchor: 'fadeOutRightBig', delay: 200 }),
  animations.fadeOutUpAnimation({ anchor: 'fadeOutUp', delay: 200 }),
  animations.fadeOutUpBigAnimation({ anchor: 'fadeOutUpBig', delay: 200 }),
  animations.flipAnimation({ anchor: 'flip', delay: 200 }),
  animations.flipInXAnimation({ anchor: 'flipInX', delay: 200 }),
  animations.flipInYAnimation({ anchor: 'flipInY', delay: 200 }),
  animations.flipOutXAnimation({ anchor: ' flipOutX', delay: 200 }),
  animations.flipOutYAnimation({ anchor: 'flipOutY', delay: 200 }),
  animations.lightSpeedInAnimation({ anchor: 'lightSpeedIn', delay: 200 }),
  animations.lightSpeedOutAnimation({ anchor: 'lightSpeedOut', delay: 200 }),
  animations.rotateInAnimation({ anchor: 'rotateIn', delay: 200 }),
  animations.rotateInDownLeftAnimation({ anchor: 'rotateInDownLeft', delay: 200 }),
  animations.rotateInDownRightAnimation({ anchor: 'rotateInDownRight', delay: 200 }),
  animations.rotateInUpLeftAnimation({ anchor: 'rotateInUpLeft', delay: 200 }),
  animations.rotateInUpRightAnimation({ anchor: 'rotateInUpRight', delay: 200 }),
  animations.rotateOutAnimation({ anchor: 'rotateOut', delay: 200 }),
  animations.rotateOutDownLeftAnimation({ anchor: 'rotateOutDownLeft', delay: 200 }),
  animations.rotateOutDownRightAnimation({ anchor: 'rotateOutDownRight', delay: 200 }),
  animations.rotateOutUpLeftAnimation({ anchor: 'rotateOutUpLeft', delay: 200 }),
  animations.rotateOutUpRightAnimation({ anchor: 'rotateOutUpRight', delay: 200 }),
  animations.slideInDownAnimation({ anchor: 'slideInDown', delay: 200 }),
  animations.slideInLeftAnimation({ anchor: 'slideInLeft', delay: 200 }),
  animations.slideInRightAnimation({ anchor: 'slideInRight', delay: 200 }),
  animations.slideInUpAnimation({ anchor: 'slideInUp', delay: 200 }),
  animations.slideOutDownAnimation({ anchor: 'slideOutDown', delay: 200 }),
  animations.slideOutLeftAnimation({ anchor: 'slideOutLeft', delay: 200 }),
  animations.slideOutRightAnimation({ anchor: 'slideOutRight', delay: 200 }),
  animations.slideOutUpAnimation({ anchor: 'slideOutUp', delay: 200 }),
  animations.zoomInAnimation({ anchor: 'zoomIn', delay: 200 }),
  animations.zoomInDownAnimation({ anchor: 'zoomInDown', delay: 200 }),
  animations.zoomInLeftAnimation({ anchor: 'zoomInLeft', delay: 200 }),
  animations.zoomInRightAnimation({ anchor: 'zoomInRight', delay: 200 }),
  animations.zoomInUpAnimation({ anchor: 'zoomInUp', delay: 200 }),
  animations.zoomOutAnimation({ anchor: 'zoomOut', delay: 200 }),
  animations.zoomOutDownAnimation({ anchor: 'zoomOutDown', delay: 200 }),
  animations.zoomOutLeftAnimation({ anchor: 'zoomOutLeft', delay: 200 }),
  animations.zoomOutRightAnimation({ anchor: 'zoomOutRight', delay: 200 }),
  animations.zoomOutUpAnimation({ anchor: 'zoomOutUp', delay: 200 }),
  animations.hingeAnimation({ anchor: 'hinge', delay: 200 }),
  animations.jackInTheBoxAnimation({ anchor: 'jackInTheBox', delay: 200 }),
  animations.rollInAnimation({ anchor: 'rollIn', delay: 200 }),
  animations.rollOutAnimation({ anchor: 'rollOut', delay: 200 }),
  // other
  animations.collapseAnimation({ anchor: 'collapse', delay: 200 }),
  animations.collapseHorizontallyAnimation({ anchor: 'collapseHorizontally', delay: 200 }),
  animations.rotateAnimation({ anchor: 'rotate', delay: 200 }),
  animations.rotateAnimation({ anchor: 'rotate90', degrees: 90 }),
  animations.hueRotateAnimation({ anchor: 'hueRotate', delay: 200 }),
  animations.hueRotateAnimation({ anchor: 'hueRotateA', duration: 20000 })
]